import React from 'react'

import { useSessionQuery } from '../../hooks/useSessionQuery'

interface Props {
  children: React.ReactNode
}

const SessionProvider: React.FC<Props> = ({ children }) => {
  useSessionQuery()

  return <>{children}</>
}

export default SessionProvider
